import { compileDashboardFeature, DashboardComponentType } from '@/features/dashboard'
import { FormatOptions } from '@/components/AnalyticsDashboard/formatter'
import { EntityLevel } from '@/composables/useEntityLevel'

const enabledEntityLevels: EntityLevel[] = [
  'COMPLEX',
  'REAL_ESTATE',
  'LEVEL',
  'SPACE',
  'FLOOR',
  'CONSTRUCTION'
]
const format: FormatOptions = {
  format: {
    type: 'intl-number',
    maximumFractionDigits: 2
  },
  steps: [{ format: { type: 'format-string', format: '%s kWh' } }]
}
const formatWater: FormatOptions = {
  format: {
    type: 'intl-number',
    maximumFractionDigits: 2
  },
  steps: [{ format: { type: 'format-string', format: '%s m³' } }]
}

export const newEnergyAnalysis = compileDashboardFeature({
  name: 'energyAnalysis',
  title: {
    sv: 'Energi',
    en: 'Energy '
  },
  dataSectionTitle: {
    sv: 'Energi',
    en: 'Energy'
  },
  icon: 'IconZap',
  enabled: false,
  defaultFilters: {
    calendar: {
      quickSelect: 'last30days'
    },
    defaultDateSelection: 'last30d',
    onlyBusinessHoursFilterType: 'query',
    onlyBusinessDays: false,
    onlyBusinessHours: false,
    dateSelections: [
      'now',
      'last24h',
      'yesterday',
      'last7d',
      'last30d',
      'lastquarter',
      'last12m',
      'currentyear',
      'lastyear',
      'custom'
    ]
  },
  measurements: [
    {
      name: 'metering',
      field: {
        name: 'energy_total',
        expression: {
          type: 'sum',
          exp: {
            type: 'field',
            name: 'energy_total'
          }
        }
      },
      title: {
        sv: 'Elförbrukning (fastighet)',
        en: 'Electricity consumption (property)'
      },
      options: {
        color: '#40A9FF',
        enabledEntityLevels,
        format,
        min: 0,
        max: 100
      }
    },
    {
      name: 'metering',
      field: {
        name: 'hot_water_volume',
        expression: {
          type: 'sum',
          exp: {
            type: 'field',
            name: 'hot_water_volume'
          }
        }
      },
      title: {
        sv: 'Varmvattenförbrukning',
        en: 'Hot water consumption'
      },
      options: {
        color: '#FF7A45',
        enabledEntityLevels,
        format: formatWater,
        min: 0,
        max: 100
      }
    }
  ],
  components: [
    {
      type: DashboardComponentType.Kpi,
      name: 'energy-kpi',
      measurements: ['metering.energy_total']
    },
    {
      type: DashboardComponentType.Kpi,
      name: 'hot-water-kpi',
      measurements: ['metering.hot_water_volume']
    },
    {
      type: DashboardComponentType.TimeSeries,
      name: 'timeseries-energy',
      measurements: ['metering.energy_total'],
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'path_subtree' }]
          }
        }
      },
      title: { sv: 'Elförbrukning över tid', en: 'Electricity consumption over time' }
    },
    {
      type: DashboardComponentType.BarChart,
      name: 'timeseries-energy-barchart',
      measurements: ['metering.energy_total'],
      groupKey: 'timestamp_extract_hour',
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'timestamp_extract', extract: 'HOUR' }]
          }
        }
      },
      title: { sv: 'Elförbrukning över timmar', en: 'Electricy consumption over hours' }
    },
    {
      type: DashboardComponentType.BarChart,
      name: 'timeseries-energy-barchart-week',
      measurements: ['metering.energy_total'],
      groupKey: 'timestamp_extract_isodow',
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'timestamp_extract', extract: 'ISODOW' }]
          }
        }
      },
      title: { sv: 'Elförbrukning över veckodagar', en: 'Electricy consumption over weekdays' }
    },
    {
      type: DashboardComponentType.TimeSeries,
      name: 'timeseries-hot-water',
      measurements: ['metering.hot_water_volume'],
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'path_subtree' }]
          }
        }
      },
      title: { sv: 'Varmvattenförbrukning över tid', en: 'Hot water consumption over time' }
    },
    {
      type: DashboardComponentType.BarChart,
      name: 'timeseries-hot-water-barchart',
      measurements: ['metering.hot_water_volume'],
      groupKey: 'timestamp_extract_hour',
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'timestamp_extract', extract: 'HOUR' }]
          }
        }
      },
      title: { sv: 'Varmvattenförbrukning över timmar', en: 'Hot water consumption over hours' }
    },
    {
      type: DashboardComponentType.BarChart,
      name: 'timeseries-hot-water-barchart-week',
      measurements: ['metering.hot_water_volume'],
      groupKey: 'timestamp_extract_isodow',
      filters: {
        values: {
          query: {
            groupBy: [{ type: 'timestamp_extract', extract: 'ISODOW' }]
          }
        }
      },
      title: {
        sv: 'Varmvattenförbrukning över veckodagar',
        en: 'Hot water consumption over weekdays'
      }
    }
  ],
  tabs: [
    {
      name: 'energy_electricity',
      title: { sv: 'El', en: 'Electricity' },
      components: [
        'energy-kpi',
        'timeseries-energy',
        'timeseries-energy-barchart',
        'timeseries-energy-barchart-week'
      ],
      initialShowOnMapComponent: 'energy-kpi'
    },
    {
      name: 'energy_water',
      title: { sv: 'Vatten', en: 'Water' },
      components: [
        'hot-water-kpi',
        'timeseries-hot-water',
        'timeseries-hot-water-barchart',
        'timeseries-hot-water-barchart-week'
      ],
      initialShowOnMapComponent: 'hot-water-kpi'
    }
  ]
})
